export const data2_1 = [{
    name: 'Wedding',
    Comments: "",
}, {
    name: 'Social Events',
    Comments: "",
}, {
    name: 'Group Events',
    Comments: "",
}]


// WEBPACK FOOTER //
// ./src/components/table/6.0/6-3new/data.js